import {
  PROGRAMMING,
  COMMENTARY,
  VIDEO,
  OTHER,
  CHECKIN,
} from "../task-constants";

const EmptyTasks = ({
  tab,
  organizationCoach,
  selectedTasks,
  referAsClients,
}) => {
  const tabs = {
    [PROGRAMMING]: {
      title: "No one is due for a new program",
      subTitle: `Be notified about when someone needs a new program. Program tasks will populate automatically once you push a program to ${
        referAsClients ? "a client" : "an athlete"
      }.`,
    },
    [VIDEO]: {
      title: "No videos to review",
      subTitle: `Be notified about when someone needs a video reviewed. When uploading a video to a set from the mobile app, your ${
        referAsClients ? "clients" : "athletes"
      } can select to notify their coach.`,
    },
    [COMMENTARY]: {
      title: "No comments to review",
      subTitle: `Be notified about when someone needs a comment reviewed. When uploading a comment to a set from the mobile app, your ${
        referAsClients ? "clients" : "athletes"
      } can select to notify their coach.`,
    },
    [CHECKIN]: {
      title: "No check-ins to review",
      subTitle: `Be notified when it's time to review a new ${
        referAsClients ? "client" : "athlete"
      } check-in.`,
    },
    [OTHER]: {
      title: "No custom tasks to complete",
      subTitle: "Create a task for yourself by clicking the button below.",
    },
  };

  return (
    <div className="no-tasks-section">
      <p>{tabs[tab].title}</p>
      <span>{tabs[tab].subTitle}</span>
      <a
        role="button"
        data-button-type="primary"
        href={
          organizationCoach
            ? `/coaching-portal/tasks/?modal[type]=add-task&tab=${tab}&organizationCoach=${organizationCoach}`
            : `/coaching-portal/tasks/?modal[type]=add-task&tab=${tab}`
        }
        disabled={selectedTasks.length > 0}
      >
        Add Task
      </a>
    </div>
  );
};

export default EmptyTasks;
